export { default } from './ProductFAQ';
export * from './ProductFAQ';
